export function copiarTexto(texto) {
  if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(texto);

  return new Promise((resolve, reject) => {
    const campo = document.createElement("textarea");
    campo.value = texto;
    campo.setAttribute("readonly", "");
    campo.style.position = "fixed";
    campo.style.opacity = "0";
    document.body.appendChild(campo);
    campo.select();

    try {
      if (document.execCommand("copy")) {
        resolve();
      } else {
        reject(new Error("Cópia não suportada"));
      }
    } catch (erro) {
      reject(erro);
    } finally {
      campo.remove();
    }
  });
}
